import { useTranslations } from '@aikoa/i18n/react'
import { useDeferredValue, useEffect, useState } from 'react'
import { View } from 'react-native'
import ContentBox from '~/components/layout/ContentBox'
import { Body, Label } from '~/components/typography/Content'
import { LinkButton } from '~/components/ui/button'
import { Input } from '~/components/ui/input'
import { ContactMethodsManager } from '~/components/user/ContactMethodsManager'
import { ProfileHeader } from '~/components/user/ProfileHeader'
import { useUpdateUserProfile, useUserProfile } from '~/data/user/userProfile'
import { useFakeDirty } from '~/lib/useFakeDirty'
import { cn } from '~/lib/utils'

export function BuyerProfileView({ className }: { className?: string }) {
  const updateUserProfileMutation = useUpdateUserProfile()
  const { data: profile, isLoading: isProfileLoading } = useUserProfile()
  const { t } = useTranslations('user')

  const [name, setName] = useState(profile?.name || '')
  const deferredName = useDeferredValue(name)

  useEffect(() => {
    if (
      !profile ||
      isProfileLoading ||
      !deferredName ||
      deferredName === profile?.name ||
      updateUserProfileMutation.isPending
    ) {
      return
    }

    updateUserProfileMutation.mutate({
      user_id: profile.user_id,
      name: deferredName,
    })
  }, [profile, deferredName, updateUserProfileMutation, isProfileLoading])

  const [isDirty, setIsDirty] = useFakeDirty(false)

  return (
    <ContentBox
      scrollable={false}
      contentContainerClassName="gap-4 px-0 pt-0"
      header={<ProfileHeader />}
      className={cn('flex-1 gap-4 px-6', className)}>
      <Body className="text-pretty text-center text-secondary">
        {t(($) => $.profile.buyer.description)}
      </Body>
      <View className="mx-auto mb-6 w-full max-w-2xl gap-2">
        <Label>{t(($) => $.profile.buyer.nameLabel)}</Label>
        <Input
          value={name}
          onChangeText={(text) => {
            setIsDirty(true)
            setName(text.trimStart())
          }}
          placeholder={t(($) => $.profile.buyer.namePlaceholder)}
          className={cn('font-semibold text-lg', !name && 'border-destructive/70')}
          autoFocus={false}
          variant="box"
        />
      </View>
      <ContactMethodsManager className="mb-6" onChange={() => setIsDirty(true)} />
      <LinkButton href="/(authenticated)" size="lg" variant="primary">
        {isDirty ? t(($) => $.profile.buyer.saveAndContinue) : t(($) => $.profile.buyer.continue)}
      </LinkButton>
    </ContentBox>
  )
}
